<template>
  <div class="login-page">
    <!-- Left side: form -->
    <div class="login-left">
      <div class="login-card">
        <h2 class="title">Welcome Back</h2>
        <p class="subtitle">Sign in to your account</p>

        <form @submit.prevent="login" class="form-login">
          <div class="input-group">
            <input
              type="text"
              v-model="username"
              placeholder="Username or Email"
              :class="{ 'is-invalid': usernameError }"
            />
            <div class="invalid-feedback">{{ usernameError }}</div>
          </div>

          <div class="input-group">
            <input
              type="password"
              v-model="password"
              placeholder="Password"
              :class="{ 'is-invalid': passwordError }"
            />
            <div class="invalid-feedback">{{ passwordError }}</div>
          </div>

          <button type="submit" class="btn-login" :disabled="loading">
            <span v-if="loading" class="spinner"></span>
            <span v-if="!loading">Login</span>
          </button>

          <div class="separator">OR</div>

          <button @click.prevent="loginWithGoogle" class="btn-google">
            <i class="fab fa-google"></i> Login with Google
          </button>

          <div v-if="error" class="error-message">{{ error }}</div>
        </form>

        <div class="extra-links">
          <router-link to="/register">Create Account</router-link> |
          <router-link to="/forgot-password">Forgot Password?</router-link>
        </div>
      </div>
    </div>

    <div class="login-bg"></div>
  </div>
</template>


<script>
import { auth, provider } from "@/firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";

export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
      loading: false,
      usernameError: "",
      passwordError: "",
    };
  },
  methods: {
    validateFields() {
      this.usernameError = this.username ? "" : "Username is required.";
      this.passwordError = this.password ? "" : "Password is required.";
      return !this.usernameError && !this.passwordError;
    },
    async login() {
      if (!this.validateFields()) return;
      this.loading = true;
      this.error = "";
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          this.username,
          this.password
        );
        console.log("Logged in user:", userCredential.user);
        this.$router.push("/");
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
    async loginWithGoogle() {
      this.loading = true;
      this.error = "";
      try {
        const result = await signInWithPopup(auth, provider);
        console.log("Google user:", result.user);
        this.$router.push("/");
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  display: flex;
  min-height: 100vh;
  font-family: 'Poppins', sans-serif;
}

/* Left side: form */
.login-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
 background-color: #2c787e}

/* Right side: logo / illustration */
.login-right {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login-bg {
  width: 50%;
  background-image: url("@/assets/images/login.jpeg"); /* Replace with your logo */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.login-logo {
  width: 60%;
  height: 60%;
  margin-bottom: 20px;
}
.brand-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}
.brand-subtitle {
  font-size: 16px;
  color: #555;
  text-align: center;
}

/* Card inside left */
.login-card {
  background: #fff;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.2);
  width: 380px;
  text-align: center;
}
.title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}
.subtitle {
  font-size: 14px;
  margin-bottom: 30px;
  color: #666;
}

/* Inputs */
.input-group {
  margin-bottom: 20px;
  position: relative;
}
input {
  width: 100%;
  padding: 12px 15px;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
  transition: 0.3s;
}
input:focus {
  border-color: #2c787e;
  box-shadow: #2c787e;
}
.is-invalid {
  border-color: #ff4d4f;
}
.invalid-feedback {
  font-size: 12px;
  color: #ff4d4f;
  text-align: left;
  margin-top: 5px;
}

/* Buttons */
.btn-login,
.btn-google {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: 0.3s;
}
.btn-login {
  background: #2c787e;
  color: #fff;
  margin-bottom: 15px;
}
.btn-login:hover {
  background: #2c787e;
}
.btn-google {
  background: #db4437;
  color: #fff;
}
.btn-google:hover {
  background: #c33c2e;
}

/* Spinner */
.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #fff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: inline-block;
  animation: spin 0.8s linear infinite;
  margin-right: 5px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* OR separator */
.separator {
  margin: 15px 0;
  font-size: 13px;
  color: #999;
}

/* Error message */
.error-message {
  margin-top: 15px;
  color: #ff4d4f;
  font-weight: 500;
}

/* Extra links */
.extra-links {
  margin-top: 20px;
  font-size: 13px;
  color: #666;
}
.extra-links a {
  color: #2c787e;
  text-decoration: none;
}
.extra-links a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 992px) {
  .login-page {
    flex-direction: column;
  }
  .login-left,
  .login-right {
    flex: unset;
    width: 100%;
  }
  .login-right {
    padding: 20px;
  }
}
</style>
